exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3R85EkgkAUVFSlw-Uumyom{margin-top:20px}.tnEsVNlE3fEIX99ASgfU_{padding:5px;margin:15px 0px;border:1px solid #e0e0e0;border-radius:4px;width:80px;height:80px;box-sizing:content-box}.tnEsVNlE3fEIX99ASgfU_.fYeKtOpkZQVW5E3B_zA3M{display:flex;justify-content:center;width:200px;height:200px;margin:15px auto}._39tQle7doqnfv9bPc1uK4s{color:#616161 !important;width:80px !important;padding-left:0 !important;padding-right:0 !important;text-align:right !important}\n", ""]);

// Exports
exports.locals = {
	"qrContainer": "_3R85EkgkAUVFSlw-Uumyom",
	"qrCode": "tnEsVNlE3fEIX99ASgfU_",
	"centered": "fYeKtOpkZQVW5E3B_zA3M",
	"secondaryDownload": "_39tQle7doqnfv9bPc1uK4s"
};